import { IOtp, IPhone } from "@interfaces";
import { memo, useState } from "react";

import { Form, Row, Col, Typography, Space, Button } from "antd";
import { useTranslation } from "react-i18next";
import { SharedButton, StyledAuth } from "@components";
import { selectApp, setLoading, updatePhone, updateTemp, useAppDispatch } from "@redux";

import { theme, useNotify, getApiErrorMessage } from "@utils";
import OTPInput from "react-otp-input";
import styled from "styled-components";
import { useHistory } from "react-router";
import { PATH_CHANGE_PASSWORD, PATH_FORGOT_PASSWORD } from "@configs";
import { useSelector } from "react-redux";
import { clinicApi } from "@api";
const { Text } = Typography;

const initValue: IOtp = {
  otp: "0000",
};
const inputStyle = {
  width: "30px",
  height: "30px",
  ackground: "#FFFFFF",
  border: "0.5px solid #D9D9D9",
  boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.25)",
  borderRadius: "4px",
  fontSize: "16px",
  outline: "none",
};
const continerStyle = { justifyContent: "space-between" };
export const OtpForm = memo(() => {
  const { t } = useTranslation();
  const { otpPhone } = useSelector(selectApp);
  const dispatch = useAppDispatch();
  const { success, error, warning } = useNotify();
  const history = useHistory();
  const [otpForm] = Form.useForm();
  const [otp, setOtp] = useState("");

  const valid = (val: string) => val.length === 6;
  const onFinish = async () => {
    try {
      dispatch(setLoading(true));
      if (!valid(otp)) {
        warning(t("message.otp.fail"));
      } else {
        await clinicApi.verify({ otp });
        await history.push(PATH_CHANGE_PASSWORD);
      }
    } catch (err: any) {
      error(getApiErrorMessage(err, t("message.otp.fail")));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleRequest = async () => {
    try {
      dispatch(setLoading(true));
      const res = await clinicApi.requestOtp({ phone_number: otpPhone });
      if (res.data?.token) {
        await dispatch(updateTemp(res?.data?.token));
        success(t("message.send.success"));
      }
      // unwrapResult(res);
    } catch (err: any) {
      error(getApiErrorMessage(err, t("message.otp.fail")));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };
  return (
    <StyledAuth>
      <header>
        <h4>{t("page.enter_otp_code")}</h4>
        <p>
          {t("page.we_send_phone")}&nbsp;
          <Text type="warning">{otpPhone}</Text>
        </p>
      </header>
      <Form
        form={otpForm}
        name="basic"
        initialValues={initValue}
        onFinish={onFinish}
        layout="vertical"
      >
        <Row gutter={{ md: 54, lg: 54 }}>
          <Col lg={24} md={24} sm={24}>
            <Form.Item name="otp">
              <StyledSpaceInner>
                <OTPInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  placeholder="----"
                  inputStyle={inputStyle}
                  containerStyle={continerStyle}
                  renderInput={(props) => <input {...props} />}
                />
              </StyledSpaceInner>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={{ md: 54, lg: 54 }}>
          <Col lg={8} md={8} sm={8} />
          <Col lg={8} md={8} sm={8}>
            <SharedButton type="primary" htmlType="submit" size="middle">
              {t("page.confirm")}
            </SharedButton>
          </Col>
          <Col lg={8} md={8} sm={8} />
        </Row>
        <Row gutter={{ md: 54, lg: 54 }}>
          <Col lg={4} md={4} sm={4} />
          <Col lg={16} md={16} sm={16}>
            <StyledFlex>
              <p>{t("page.if_you_do_not_code")}</p>
              <Button type="link" onClick={handleRequest}>
                {t("page.here")}
              </Button>
            </StyledFlex>
          </Col>
          <Col lg={4} md={4} sm={4} />
        </Row>
      </Form>
    </StyledAuth>
  );
});
const StyledFlex = styled.div`
  display: flex;
  align-items: center;
`;
const StyledSpaceInner = styled.div`
  width: 300px;
  height: 55px;
  margin: auto;
  input {
    &:focus {
      border: 0.5px solid ${theme.colors.main} !important;
    }
  }
`;
